<template>
  <div v-if="user" class="user-avatar-container" :class="$attrs.class">
    <div v-if="editOption" class="add-avatar">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        stroke-linejoin="round"
        stroke-miterlimit="1.41421"
        clip-rule="evenodd"
        viewBox="0 0 12 12"
      >
        <circle cx="5.669" cy="5.669" r="5.669" fill="#fff" />
        <path
          class="plus"
          d="M5.669 10.187c-2.495 0-4.518-2.023-4.518-4.518 0-2.495 2.023-4.518 4.518-4.518 2.495 0 4.518 2.023 4.518 4.518 0 2.495-2.023 4.518-4.518 4.518zm1.936-5.163H6.314V3.732c0-.356-.289-.644-.645-.644-.357 0-.645.288-.645.644v1.292H3.732c-.356 0-.645.289-.645.645 0 .356.289.646.645.646h1.292v1.291c0 .356.288.645.645.645.356 0 .645-.289.645-.645V6.315h1.291c.357 0 .646-.29.646-.646 0-.356-.289-.645-.646-.645z"
        />
      </svg>
    </div>

    <div class="user-avatar">
      <img
        loading="lazy"
        src="@/assets/images/user-avatar-default.svg"
        width="13"
        height="19"
        alt=""
      />
    </div>
  </div>
  <div v-else class="user-avatar" :class="$attrs.class">
    <img
      loading="lazy"
      src="@/assets/images/user-avatar-default.svg"
      width="13"
      height="19"
      alt=""
    />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    user?: object | null
    editOption?: boolean
  }>(),
  {
    editOption: false,
    user: null,
  },
)
</script>

<style scoped>
.user-avatar-container {
  position: relative;
  z-index: 2;
  top: 0;
  left: auto;
  right: auto;
  margin: auto;
  width: 4em;
  height: 4em;
}

.user-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: var(--colour-header-dark-blue);
  overflow: hidden;
  position: relative;
  border: 4px solid white;
}

.add-avatar {
  display: block;
  width: 2em;
  height: 2em;
  position: absolute;
  z-index: 1;
  right: 0;
  bottom: 0;
}

.user-avatar img {
  width: 75%;
  max-width: 75%;
  height: auto;
  position: absolute;
  left: 13%;
  top: 14%;
}

.plus {
  fill: var(--colour-orange);
}
</style>
